import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import CountBadge from 'components/atoms/CountBadge'
import palette from 'theme/palette'
import { fetchUnreadCount } from '../model/releaseNotesSlice'

const BadgeLink = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: #202020;
  font-size: 14px;
  padding: 0 4px;

  &:hover {
    color: ${palette.accent.color};
  }
`

const ReleaseBadge = () => {
  const { t } = useTranslation(['release_notes'])
  const dispatch = useDispatch()
  const count = useSelector(({ releaseNotes }) => releaseNotes.unreadCount)

  useEffect(() => {
    dispatch(fetchUnreadCount())
    const interval = setInterval(() => dispatch(fetchUnreadCount()), 60000 * 60)
    return () => clearInterval(interval)
  }, [dispatch])

  if (count === 0) return null

  return (
    <BadgeLink to="/whats-new" activeStyle={{ color: palette.accent.color }}>
      {t('release_notes:badge.link_label', 'Что нового')}
      <CountBadge>{count}</CountBadge>
    </BadgeLink>
  )
}

export default ReleaseBadge
